import api from "../../utils/apiCliente";

export const crearPaymentIntent = async (grupo_reserva) => {
  const res = await api.post(
    "/api/checkout/stripe/crear-intent",
    { grupo_reserva }
  );
  return res.data;
};

export const getPedidoByPaymentIntent = async (paymentIntentId) => {
  const { data } = await api.get(
    `/api/checkout/stripe/order-by-intent/${encodeURIComponent(paymentIntentId)}`
  );
  return data;
};
